// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { Container, Row, Col, Media } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import styles from './FeatureSection.module.scss';

const FeatureSection: PageComponent = () => {
    return (
        <Container as="section" className={styles.section_features}>
            <h1 className={styles.title}>
                <Trans
                    i18nKey="features.title"
                    ns="landingFeaturesReasonsTechnology"
                >
                    Priežastys ir technologija
                </Trans>
            </h1>
            <p className={styles.desc}>
                <Trans
                    i18nKey="features.description"
                    ns="landingFeaturesReasonsTechnology"
                >
                    Greitis. Stabilumas. Kokybė
                </Trans>
            </p>

            <Row>
                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/team.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.team.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Kvalifikuoti darbuotojai
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.team.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Mūsų įmonėje dirba kvalifikuoti, ilgalaikę
                                    patirtį serverių administravimo srityje
                                    turintys darbuotojai, kurie visuomet
                                    stengsis padėti.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>
                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/discount.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.discount.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Gera kaina
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.discount.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Mes siūlome tinkamiausią, bet ne brangiausią
                                    variantą siekiant patenkinti kliento
                                    lūkesčius. Lankstūs apmokėjimo būdai.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>

                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/clock.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.monitoring.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Stebėjimas
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.monitoring.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    24 valandas per parą stebime duomenų centro
                                    veiklą, todėl kilus nesklandumams
                                    maksimaliai greitai galime juos likviduoti.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>
                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/fair.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.fair.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Sąžiningumas
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.fair.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Skaidriai ir aiškiai apibūdiname mūsų
                                    teikiamas paslaugas neklaidindami klientų
                                    siekiant juos privilioti apgaulės būdu.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>

                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/shield.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.guarantee.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Garantija
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.guarantee.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Suteikiame 30 dienų pinigų grąžinimo
                                    garantiją - jei esate nepatenkinti mūsų
                                    paslaugomis - grąžinsime pinigus.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>
                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/folder.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.ownDc.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Nuosavas duomenų centras
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.ownDc.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    kontroliuojame visą paslaugų teikimo
                                    procesą, todėl galime teikti ne tik
                                    kompleksines paslaugas, bet ir užtikrinti
                                    aukštą paslaugų pasiekiamumą.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>

                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/copy-alt.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.dailyBackups.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Kasdienės duomenų kopijos
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.dailyBackups.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Kiekvieną dieną visiems virtualiems
                                    privatiems serveriams daromos atsarginės
                                    duomenų kopijos į atskirą nutolusį serverį.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>
                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/database.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.hardware.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Įranga
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.hardware.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Valdome ir turime nuosavą premium klasės
                                    įrangą, kuri užtikrina aukštos kokybės
                                    paslaugas. Siūlome itin platų paslaugų
                                    spektrą.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>

                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/network.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.network.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Tinklo pralaidumas
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.network.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Duomenų centro tinklo pralaidumas siekia 80
                                    Gbps ir yra balansuojamas tarp kelių
                                    skirtingų interneto tiekėjų, todėl Jūsų
                                    serveris pasiekiamas per trumpiausią kelią
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>
                <Col sm={12} lg={6}>
                    <Media className={styles.media}>
                        <div className={styles.media_img}>
                            <div className={styles.media_img_container}>
                                <div className={styles.media_img_inner}>
                                    <img src="/static/img/icons/update.svg" />
                                </div>
                            </div>
                        </div>
                        <Media.Body className={styles.media_body}>
                            <h5 className="mt-0">
                                <Trans
                                    i18nKey="features.updates.title"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Atnaujinimai
                                </Trans>
                            </h5>
                            <p>
                                <Trans
                                    i18nKey="features.updates.description"
                                    ns="landingFeaturesReasonsTechnology"
                                >
                                    Periodiškai naujiname serverių, tinklo bei
                                    kitą, tiek techninę, tiek ir programinę
                                    įrangą, todėl mūsų klientai visuomet
                                    naudojasi naujausia bei našiausia įranga.
                                </Trans>
                            </p>
                        </Media.Body>
                    </Media>
                </Col>
            </Row>
        </Container>
    );
};

export default FeatureSection;
